export class RecordType {
  static get Work () {
    return 1
  }
  static get Back () {
    return 2
  }
  static get Reject () {
    return 3
  }
  static get New () {
    return 4
  }
  static get Update () {
    return 5
  }
  static get Cancel () {
    return 6
  }

  static RecordTypeName (RecordType) {
    let tmpType = parseInt(RecordType)
    let type = isNaN(tmpType) ? -1 : tmpType
    let name = ''
    switch (type) {
      case 1:
        name = '派給'
        break
      case 2:
        name = '收回'
        break
      case 3:
        name = '收回(工程師拒絕)'
        break
      case 4:
        name = '新增'
        break
      case 5:
        name = '更新'
        break
      case 6:
        name = '取消'
        break
    }
    return name
  }
}
